
import { gql } from '@apollo/client';

export const GET_PHONE_FIELDS = gql`
  query UserPhoneFields($personId: Int!) {
    user(personId: $personId) {
      canEditPhone
      phone
    }
  }
`;
